module.exports = __webpack_public_path__ + "static/media/office-depot-logo.150cbf52.png";